<!-- 首席服务员 -->
<template>
    <div class="frame__xx">
        <div class="cheif_contaniner">
            <!--左边-->
            <div class="box_f1 box box_v" style="margin-right: 10px">
                <left1 class="box box_f1" style="margin-bottom: 10px"></left1>
                <left2 class="box box_f1" style="margin-bottom: 10px"></left2>
            </div>
            <!--中间-->
            <div class="box_f2 box box_v" style="margin: 0 10px">
                <div class="box box_f2 box_v" style="margin-bottom: 10px">
                    <middle1 class="box" style="margin-bottom: 5px"></middle1>
                    <middle2 class="box_f1"></middle2>
                </div>
                
            </div>
            <!--右边-->
            <div class="box_f1 box box_v" style="margin-left: 10px">
                <right1 class="box box_f1" style="margin-bottom: 10px"></right1>
                <right2 class="box box_f1" style="margin-bottom: 10px"></right2>
                
            </div>
        </div>

        <div class="bottom">
            <div class="left_xx">
                <middle3 ></middle3>
            </div>

            <div class="right_xx">
                <right3 ></right3>
            </div>
        </div>
    </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import left1 from "./left1";
import left2 from "./left2";

import middle1 from "./middle1";
import middle2 from "./middle2left";
import middle3 from "./middle3";
import right1 from "./right1";
import right2 from "./right2";
import right3 from "./right3";
export default {
    //import引入的组件需要注入到对象中才能使用
    components: {
        left1,
        left2,
 
        middle1,
        middle2,
        middle3,
        right3,
        right2,
        right1,
    },
    data() {
        //这里存放数据
        return {};
    },
    props: {
        show: {
            type: Boolean,
            default: false,
        },
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {},
    //方法集合
    methods: {},
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {},
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {},
    beforeCreate() {}, //生命周期 - 创建之前
    beforeMount() {}, //生命周期 - 挂载之前
    beforeUpdate() {}, //生命周期 - 更新之前
    updated() {}, //生命周期 - 更新之后
    beforeDestroy() {}, //生命周期 - 销毁之前
    destroyed() {}, //生命周期 - 销毁完成
    activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang='less' scoped>
//@import url(); 引入公共css类
.cheif_contaniner {
    width: 100%;
    height: 70%;
    display: flex;
}
.bottom {
    width: 100%;
    height: 30%;
    display: flex;
    justify-content: space-between;
    .left_xx,.right_xx{
        width: 49.5%;
        height: 100%;
    }
}
.middle_left {
    position: absolute;
    top: 0;
    left: 0;
    right: calc(50% + 10px);
    bottom: -10px;
}
.middle_right {
    position: absolute;
    top: 0;
    left: calc(50% + 10px);
    right: 0;
    bottom: -10px;
}

</style>